import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface CTASectionProps {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function CTASection({
  eyebrow = "Ready when you are",
  title,
  subtitle,
  primaryLabel = "Book Appointment",
  primaryTo = "/book",
  secondaryLabel = "View Quick Pricing",
  secondaryTo = "/pricing",
}: CTASectionProps) {
  return (
    <section className="px-4 md:px-8 py-12 sm:py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto text-center flex flex-col items-center">
        <div className="inline-flex items-center gap-2 mb-5 px-3 py-1 rounded-full bg-background-100 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          {eyebrow}
        </div>
        <h2 className="text-3xl sm:text-4xl md:text-6xl font-heading font-semibold tracking-tight text-foreground-950 leading-[1.05] max-w-3xl">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-4 sm:mt-5 text-sm sm:text-base md:text-lg text-foreground-600 max-w-xl">
            {subtitle}
          </p>
        )}
        <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
          <Link
            to={primaryTo}
            className="group inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3.5 sm:py-4 rounded-full bg-primary-950 text-background-50 text-sm font-semibold hover:bg-primary-900 transition-all hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
          >
            {primaryLabel}
            <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
          </Link>
          <Link
            to={secondaryTo}
            className="inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3.5 sm:py-4 rounded-full bg-transparent text-foreground-800 text-sm font-semibold hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
          >
            {secondaryLabel}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}